/* angular:styles/component:css;e60afa3aac7430d68bb7898d81c6cbebef96f6e9529adbf69750fe43c59cb628;/app/frontend_mobile/src/app/components/buttons/interrompi-ricarica/interrompi-ricarica.component.ts */
/*# sourceMappingURL=interrompi-ricarica.component.css.map */
